import {Button} from "../../ui/Button";
import {LinkToProduct, openUrlInNewTab} from "../../pages/HomePage";
import {LucideArrowRight} from "lucide-react";


export const PurchaseCtaSection = () => {
    return (
        <section id="koop-nu" className="bg-surface-50 py-16 lg:py-24">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                
                <h2 className="font-display text-3xl text-surface-900">
                    Bestel Jouw Peesential
                </h2>
                
                <p className="mt-3 text-surface-700 text-lg">
                    Profiteer van <b>gratis</b> verzending & <b>30-dagen</b> bedenktijd
                </p>
                
                <div className="mt-8 inline-flex flex-col items-center gap-4">

                    <GoToProductListingButton
                        linkToProduct={LinkToProduct}
                        buttonText="Ga naar Bol.com"
                    />
                    
                </div>
            </div>
        </section>
    );
};

interface ProductListingProps {
    linkToProduct: string;
    buttonText: string;
}

export const GoToProductListingButton: React.FC<ProductListingProps> = ({ linkToProduct, buttonText }) => {
    return(
        <Button
            onClick={() => openUrlInNewTab(linkToProduct)}
            className="group relative px-6 py-3"
        >
            {buttonText}
            <LucideArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
        </Button>
    );
};



